import ShadowCoord from "./ShadowCoord.glsl";
import ShadowFragmentDeclaration from "./ShadowFragmentDeclaration.glsl";
import shadow_sample_tent from "./shadow_sample_tent.glsl";
import ShadowVertexDeclaration from "./ShadowVertexDeclaration.glsl";
import ShadowVertex from "./ShadowVertex.glsl";

export default {
  ShadowCoord,
  ShadowFragmentDeclaration,
  shadow_sample_tent,
  ShadowVertexDeclaration,
  ShadowVertex
};
